export const HeaderTitle = [
    {
        name: 'Home',
        link: ''
    },
    {
        name: 'Mint',
        link: 'mint'
    },
    {
        name: 'Whitepaper',
        link: 'whitepaper'
    },
    {
        name: 'Launch',
        link: 'launch'
    },
]

export const FooterLink = ['twitter', 'telegram', 'discord', 'solana', 'doc']